import removeConversationData from './helpers/removeConversationData';
import removeItemData from './helpers/removeItemData';
import { toggleSelectRow } from 'owa-mail-actions';
import MailListItemSelectionSource from 'owa-mail-store/lib/store/schema/MailListItemSelectionSource';
import { action } from 'satcheljs/lib/legacy';
export default action('removeRowData')(function removeRowData(rowKey, tableView) {
    // 1. If the row being removed is selected, remove item from selected item ids.
    // This should be done before we delete tableRowRelationKey as this sets
    // isSelected property on it.
    if (tableView.selectedRowKeys.has(rowKey)) {
        toggleSelectRow(tableView, rowKey, false /* isUserNavigation */, MailListItemSelectionSource.RowRemoval);
    }
    // 2. Remove the row data
    switch (tableView.tableQuery.listViewType) {
        case 0 /* Conversation */:
            removeConversationData(rowKey, tableView);
            break;
        case 1 /* Message */:
            removeItemData(rowKey, tableView);
            break;
    }
});
//# sourceMappingURL=removeRowData.js.map